<template>
  <div>
    <b-row v-if="stats">
      <b-col>
        <stats-card :title="'Total ' + statusTitle + ' Units'"
                    type="gradient-info"
                    :sub-title="stats.total.toString()"
                    icon="fas fa-home">
            <template slot="info">
              <i class="fas fa-info-circle" v-b-popover.hover.bottom="'This number represents listings counted towards your unit goal.'"></i>
            </template>
        </stats-card>
      </b-col>
      <b-col>
        <stats-card :title="'Total ' + statusTitle + ' Volume'"
                    type="gradient-danger"
                    :sub-title="stats.volume | currency"
                    icon="fas fa-dollar-sign">
          <template slot="info">
            <i class="fas fa-info-circle" v-b-popover.hover.bottom="'This number represents listings counted towards your unit goal.'"></i>
          </template>
        </stats-card>
      </b-col>
      <b-col v-if="stats.showGci">
        <stats-card :title="'Total ' + statusTitle + ' GCI'"
                    type="gradient-danger"
                    :sub-title="stats.gci | currency"
                    icon="fas fa-dollar-sign">
        </stats-card>
      </b-col>
      <b-col>
        <stats-card :title="'Total ' + statusTitle + ' Gross Profit'"
                    type="gradient-danger"
                    :sub-title="stats.profits | currency"
                    icon="fas fa-dollar-sign">
        </stats-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';

export default {
  mixins: [errorsMixin],
  props: {
    year: null,
    status: null,
    searchQuery: null,
    orderBy: null,
    userRoute: null
  },
  data() {
    return {
      stats: null,
    }
  },
  computed: {
    statusTitle() {
      return this.status.length > 0 ? this.status : 'Listings';
    }
  },
  methods: {
    async getStats() {
      const params = "?year=" + this.year + "&status=" + this.status + "&orderBy=" + this.orderBy + "&searchQuery=" + this.searchQuery;
      axios.get(this.userRoute + "/listing-totals" + params)
      .then(response => {
        this.stats = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    }
  },
  created() {
    this.getStats()
  },
  watch: {
    year(to, from) {
      this.getStats();
    },
    status(to, from) {
      this.getStats();
    },
    searchQuery(to, from) {
      this.getStats();
    }
  }
};
</script>
<style>
.fa-info-circle {
  position: absolute;
  top: 3px;
  right: 3px;
}
</style>